import { render } from "./ModulAbholen.vue?vue&type=template&id=28925686"
import script from "./ModulAbholen.vue?vue&type=script&lang=js"
export * from "./ModulAbholen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__